import { makeProxyRequest } from '../utils/request';
import { generic, rpc } from './helper';

export const getWLCompanyDataAPI = () =>
  makeProxyRequest('get', generic('/whitelabelconfig'));

export const getCustomConfigAPI = testSlug =>
  makeProxyRequest('get', rpc(`/test/${testSlug}/custom-config/`));
